import { useEffect, useState } from 'preact/compat'

export default function useFetch(url, headers = {}) {
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [refetchIndex, setRefetchIndex] = useState(0)

  const refetch = () =>
    setRefetchIndex((prevRefetchIndex) => prevRefetchIndex + 1)

  function handleApiResponse(response, controller) {
    if (controller.signal.aborted) {
      return Promise.resolve(null)
    }

    return response.json().then((json) => {
      if (!response.ok) {
        const error = {
          status: response.status,
          message: json.message,
        }

        return Promise.reject(error)
      }

      return json
    })
  }

  useEffect(() => {
    const controller = new AbortController()

    setLoading(true)

    window
      .fetch(url, Object.assign({ headers }, { signal: controller.signal }))
      .then((response) => {
        return handleApiResponse(response, controller)
      })
      .then(setResult)
      .catch((error) => {
        if (controller.signal.aborted) return

        if (error instanceof Error) {
          const unknownError = {
            status: 500,
            message: error.message,
          }

          setError(unknownError)
        } else {
          setError(error)
        }
      })
      .then(() => {
        setLoading(false)
      })

    return () => {
      controller.abort()
    }
  }, [url, headers, refetchIndex])

  return {
    result,
    error,
    loading,
    refetch,
  }
}
